import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ComponentProps, ReactElement } from "react";

import { black24 } from "../../../theme/theme";

interface IIconCircleButtonProps extends Omit<ComponentProps<typeof IconButton>, "color"> {
	onClick: (event: React.MouseEvent<HTMLElement>) => void;
	color?: string;
	icon: IconProp;
	transparent?: boolean;
	outlined?: boolean;
}

export const CircleIconButton = ({
	icon,
	color,
	onClick,
	outlined,
	sx,
	disabled,
	...props
}: IIconCircleButtonProps): ReactElement => {
	const theme = useTheme();
	return (
		<Box>
			<IconButton
				onClick={onClick}
				sx={{
					height: "32px",
					width: "32px",
					justifyContent: "center",
					alignItems: "center",
					display: "flex",
					...(outlined && {
						border: `1px solid ${disabled ? black24 : theme.palette.primary.main}`
					}),
					...sx
				}}
				disabled={disabled}
				size="small"
				{...props}
			>
				<FontAwesomeIcon color={disabled ? black24 : color || theme.palette.primary.main} icon={icon} size={"sm"} />
			</IconButton>
		</Box>
	);
};
